import { useMemo } from 'react';

import { useGPTStore } from '@/store';

export const usePaymentInfo = () => {
  const { quotaInfo } = useGPTStore((state) => state);

  const fileLimitSize = useMemo(() => {
    // return paymentInfo ? paymentInfo.max_upload_file : 3;
    // 应产品要求写死100M
    return 100;
  }, [quotaInfo]);

  return {
    fileLimitSize,
  };
};
